import { memo, useState, useEffect } from "react";
import Image from "react-bootstrap/Image";
import { domainOnly } from "../../../../utils/formatUtils";

// Deterministic hue from the domain so a site's fallback tile is stable and
// each site gets a distinct-but-calm colour.
const hueFromString = (str = "") => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash) % 360;
};

export const Icon = memo(
  ({ title, url, isEncrypted, iconSize = 16, wrapperSize = "md" }) => {
    const [failed, setFailed] = useState(false);

    // Reset the error state if the bookmark this icon renders changes.
    useEffect(() => setFailed(false), [url]);

    const faviconUrl = `${
      process.env.REACT_APP_API_URL
    }/v1/preview/favicon?url=${encodeURIComponent(url)}`;

    // Monogram fallback source: the domain reads better than the (often long)
    // page title.
    const label = (domainOnly(url) || title || "?").replace(/^www\./, "");
    const letter = (label.match(/[a-z0-9]/i)?.[0] || "?").toUpperCase();
    const hue = hueFromString(label);

    return (
      <div
        className={`icon icon-${wrapperSize} bg-${
          isEncrypted ? "success bg-opacity-10" : "light"
        } d-flex justify-content-center align-items-center`}
      >
        {isEncrypted ? (
          <i className="fs-4 bi bi-lock-fill text-success d-flex"></i>
        ) : failed ? (
          <span
            className="icon-monogram"
            style={{
              fontSize: Math.round(iconSize * 0.85),
              color: `hsl(${hue}, 55%, 55%)`,
              backgroundColor: `hsl(${hue}, 55%, 55%, 0.14)`,
            }}
            aria-label={`${title} icon`}
          >
            {letter}
          </span>
        ) : (
          <Image
            src={faviconUrl}
            fluid
            width={iconSize}
            height={iconSize}
            loading="lazy"
            decoding="async"
            alt={`${title} favicon`}
            fetchpriority="low"
            referrerPolicy="no-referrer"
            onError={() => setFailed(true)}
          />
        )}
      </div>
    );
  }
);
